import React, { useState } from 'react';
import { arrayOf } from 'prop-types';
import { Collapse } from 'react-bootstrap';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';

import { history } from 'utils';

import { sideMenuLink } from './types';

import './style.scss';

function ExpandMenuIcon({ show, opened, setOpened }) {
  return (
    <span onClick={(e) => e.stopPropagation()} className="prepend-icon">
      {show && (
        <span onClick={setOpened}>
          <span
            className={
              opened ? 'arrow_triangle-right opened' : 'arrow_triangle-right'
            }
          />
        </span>
      )}
    </span>
  );
}

function SideMenuLink({ option, closeMenu }) {
  const navigate = useNavigate();

  const [opened, setOpened] = useState(false);
  const hasChildren = !!option.children.length;
  const menuLevel = option.link.split('/').length - 1;
  const isActiveGroup =
    (menuLevel === 1 || hasChildren) &&
    history.location.pathname.includes(option.link);
  const isActiveSubGroup =
    menuLevel > 1 && history.location.pathname === option.link;
  return (
    <div className="side-menu-item">
      <div
        className={classNames('side-menu-link ', {
          active: isActiveGroup,
          exact: isActiveSubGroup,
        })}
        style={{ paddingLeft: `${menuLevel * 0.5 + 1}em` }}
        onClick={() => {
          setOpened(true);
          closeMenu();
          navigate(option.link);
        }}
      >
        <ExpandMenuIcon
          opened={opened}
          show={hasChildren}
          setOpened={() => setOpened((o) => !o)}
        />
        {option.icon}
        <span
          style={{ fontSize: `${16 - menuLevel}px` }}
          onClick={() => {
            closeMenu();
            navigate(option.link);
          }}
        >
          {option.title}
        </span>
      </div>
      <Collapse in={hasChildren && opened}>
        <div className="side-menu-subsection">
          {option.children.map((subOption) => (
            <SideMenuLink
              key={subOption.key}
              closeMenu={closeMenu}
              option={subOption}
            />
          ))}
        </div>
      </Collapse>
    </div>
  );
}

SideMenuLink.propTypes = {
  option: sideMenuLink.isRequired,
};

function SideMenu({ options, closeMenu }) {
  return (
    <nav className="mt-5 mt-md-0">
      {options.map((option) => (
        <SideMenuLink key={option.key} closeMenu={closeMenu} option={option} />
      ))}
    </nav>
  );
}

SideMenu.propTypes = {
  options: arrayOf(sideMenuLink).isRequired,
};

export default SideMenu;
